import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeEquipoRadiologico, setEquipoRadiologico } from "../../../../../../../redux/actions/resolucion";
import EquipoRadiologicoSimpleTable from "./table/EquipoRadiologicoSimpleTable";
import EquipoRadiologicoTabs from "./tabs/EquipoRadiologicoTabs";

const EquipoRadiologicoTableContainer = () => {
  const dispatch = useDispatch();
  const equiposRadiologicos = useSelector((state) => state.resolucion.abmSustancia.equiposRadiologicos);
  const [openDialog, setOpenDialog] = useState(false);

  const handleDelete = (indices) => {
    dispatch(removeEquipoRadiologico(indices));
  };

  const handleOpenEquipoRadiologicoTabs = (rowData = {}) => {
    dispatch(setEquipoRadiologico(rowData, rowData?.index ?? null));
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  return (
    <>
      <EquipoRadiologicoSimpleTable
        data={equiposRadiologicos}
        handleOpenForm={handleOpenEquipoRadiologicoTabs}
        handleDelete={handleDelete}
      />
      <EquipoRadiologicoTabs
        open={openDialog}
        handleClose={handleClose}
      />
    </>
  );
};

export default EquipoRadiologicoTableContainer;
